import {useMutation} from "@tanstack/react-query";
import {Address, UtilsApi} from "@devour/client";

/**
 * Resolve a Google Place ID into a full Address object.
 */
export function useGetAddressFromPlaceId() {
    return useMutation<Address, unknown, string>({
        mutationFn: async (placeId: string) => {
            return new UtilsApi().getAddressFromPlaceId({placeId});
        },
    });
}
